import { baseApi } from './baseApi';

const rootMiddlewares = [baseApi.middleware];

export default rootMiddlewares;
